<template>
    <client-page>
        <!-- <sub-visual :subTabNone="$route.params._campaign" sh="캠페인" tabActive="캠페인" bg="/images/sub/visual/sv4.jpg"> </sub-visual> -->
        <!-- <sub-visual sh="캠페인" tabActive="캠페인" bg="/images/sub/visual/sv4.jpg"> </sub-visual> -->

        <section class="section">
            <v-container>
                <div class="section-title-wrap">
                    <h2 class="client-title--xxxl">캠페인 후원</h2>
                </div>

                <campaign-tabs />

                <v-row>
                    <!-- <v-col cols="12" md="6" lg="4">
                        <v-card flat tile outlined to="/">
                            <v-img src="/" />
                            <v-card-title class="font-size-16 font-size-md-18"></v-card-title>
                        </v-card>
                    </v-col> -->
                </v-row>

                <!-- <campaign-list v-if="!$route.params._campaign && $route.query.mode !== 'input'" /> -->
                <!-- <campaign-write v-else-if="$route.query.mode === 'input'"/>
                <campaign-view v-else/>  -->
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import CampaignView from "@/components/client/support/campaign-view.vue";
import CampaignList from "@/components/client/support/campaign-list.vue";
import CampaignWrite from "@/components/client/support/campaign-write.vue";
import CampaignTabs from '@/components/client/dumb/campaign-tabs.vue';

export default {
    components: {
        ClientPage,
        SubVisual,
        CampaignView,
        CampaignList,
        CampaignWrite,
        CampaignTabs,
    },
    data() {
        return {
            tab: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {},
    },
    watch: {
        query() {},
    },
};
</script>

<style lang="scss" scoped>
.v-tabs--primary {
    .v-tab {
        &:first-child {
            border-radius: 999px 0 0 999px;
        }
        &:last-child {
            border-radius: 0 999px 999px 0;
        }
    }
}
</style>